import { CoreSetting, SettingsService } from './../../pages/settings/settings.service';
import { StatusMessageResultDto } from './../../pages/general/project.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { DisplacementData, DisplacementDto, EsoService,  UpsertLevelingDisplacementMultipleDto } from './../../pages/eso/eso.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { ForecastService } from 'src/app/pages/forecast/forecast.service';

import { ConfirmationPopUpService } from 'src/app/services/confirmation-pop-up.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';

@Component({
    selector: 'app-leveling',
    templateUrl: './leveling.component.html',
    styleUrls: ['./leveling.component.scss'],
    standalone: false
})
export class LevelingComponent implements OnInit {
	@Input() public selectedTableRecords: any[] = [];
	public selectedTableRecordsEsoObjectsIds: number[] = [];

	@Input() public selectedPeriod: string = 'YearWeek';

	@ViewChild("IntersectionGrid", { static: false }) public intersectionGridComponent: DxDataGridComponent;

	// public filterOptions: OverviewFiltersOutput = new OverviewFiltersOutput();
	// public filterList: OverviewFilterInput[] = [];

	public isSplitBasedOnLeveledForecast: boolean = false;
	public isSplitBasedOnLevelledForecastDefaultValue: CoreSetting;

	public selectBoxValue: string = "DemandQuantity";
	public selectBoxData: string[] = ["DemandQuantity", "Quanitity"];

	public levelingTopSideGridColumns: { columnName: string; caption: string }[] = [
		{
			columnName: "Quanitity",
			caption: "Quantity"
		},
		{
			columnName: "Period",
			caption: "Period"
		},
	];

	public levelingLeftSideGridColumns: { columnName: string; caption: string }[] = [
		{
			columnName: "DemandQuantity",
			caption: "Demand Quantity"
		},
		{
			columnName: "Count",
			caption: "Count"
		},
		{
			columnName: "Period",
			caption: "Period"
		},
	];

	public levelingSideGridData: any[] = [];

	public levelingSideGridDataSource: DataSource = new DataSource(
		{
			load: (loadOptions): Promise<any> => {
				const observable$ = this._esoService.getLevelingGridData(
					this.selectedTableRecordsEsoObjectsIds,
					{
						showLoadingIndicator: false,
					}
				).toPromise();

				return observable$.then(
					(response) => {
						this.levelingSideGridData = response;

						this.displacementDataSource.load();

						return response;
					}
				);
			}
		}
	);

	public intersectionGridColumns: { columnName: string; caption: string }[] = [
		// {
		// 	columnName: "EsoObjectId",
		// 	caption: "EsoObjectId"
		// },
		// {
		// 	columnName: "DisplaceFrom",
		// 	caption: "Displace From"
		// },
		// {
		// 	columnName: "DisplaceTo",
		// 	caption: "Displace To"
		// },
		// {
		// 	columnName: "DisplaceQty",
		// 	caption: "Displace Qty"
		// },
		// {
		// 	columnName: "Count",
		// 	caption: "Count"
		// },
	];
	public intersectionGridData: any[] = [
		// {
		// 	EsoObjectId: 20,
		// 	DisplaceFrom: "5123",
		// 	DisplaceTo: "623",
		// 	DisplaceQty: 510,
		// 	Count: 20
		// },
	];

	private initializeIntersectionGrid(displacementData: DisplacementData[]) {
		this.intersectionGridData = [];

		for (let a = 0; a < this.levelingSideGridData.length; a++) {
			this.intersectionGridData.push({});
		}

		this.intersectionGridColumns = [];

		for (let a = 0; a < this.levelingSideGridData.length; a++) {
			const data: any = this.levelingSideGridData[a];

			this.intersectionGridColumns.push({ columnName: data.Period, caption: data.Period });

			for (let b = 0; b < this.levelingSideGridData.length; b++) {
				if (b > a) {
					this.intersectionGridData[b][data.Period] = null;
				} else {
					this.intersectionGridData[b][data.Period] = "X";
				}

				for (let c = 0; c < displacementData.length; c++) {
					if (!this.intersectionGridData[b][data.Period]) {
						if (displacementData[c].DisplaceFrom === this.levelingSideGridData[b].Period && displacementData[c].DisplaceTo === data.Period) {
							this.intersectionGridData[b][data.Period] = displacementData[c].DisplaceQty;
						}
					}
				}
			}
		}

		console.log("Columns: ", this.intersectionGridColumns, "\nData: ", this.intersectionGridData);
	}

	public displacementDataSource: DataSource = new DataSource(
		{
			load: (loadOptions): Promise<any> => {
				const observable$ = this._esoService.getLevelingDisplacement(
					// this.filterOptions.action,
					// this.filterOptions.filters,
					// this.selectedTableRecords,
					// this.selectedPeriod
					this.selectedTableRecordsEsoObjectsIds,
					{
						showLoadingIndicator: false,
					}
				).toPromise();

				return observable$.then(
					(response) => {
						this.initializeIntersectionGrid(response);

						this.intersectionGridComponent.instance.repaint();

						return response;
					}
				);
			}
		}
	);

	public onGridRowInserted(event) {
		console.log("onGridRowInserted - event:", event);


	}

	public onGridRowUpdated(event) {
		console.log("onGridRowUpdated - event:", event);


	}

	public onGridRowRemoved(event) {
		console.log("onGridRowRemoved - event:", event);


	}

	// public reloadData(): void {
	// 	this.gridDataSource.reload();
	// }

	private focusedCellData: any;

	public intersectionGridOnFocusedCellChanged(event: any): void {
		console.log("intersectionGridOnFocusedCellChanged - event:", event);

		this.focusedCellData = event;
	}

	private updatedCellData: any;

	public intersectionGridOnEditingStart(event: any): void {
		console.log("intersectionGridOnEditingStart - event:", event);

		this.updatedCellData = this.focusedCellData;
	}

	// public updatedIntersectionGridCellsDtos: UpsertLevelingDisplacementDto[] = [];
	public upsertLevelingDisplacementMultipleDto: UpsertLevelingDisplacementMultipleDto = new UpsertLevelingDisplacementMultipleDto();

	public intersectionGridOnRowUpdated(event: any): void {
		console.log("intersectionGridOnRowUpdated - event:", event);

		let rowData: any = event.data;

		let columnPeriod: string = this.intersectionGridColumns[this.updatedCellData.columnIndex].columnName;
		let rowPeriod: string = this.intersectionGridColumns[this.updatedCellData.rowIndex].columnName;

		if (this.updatedCellData.columnIndex >= this.updatedCellData.rowIndex) {
			console.warn("It's not allowed to edit this cell. Repainiting grid.");

			this.intersectionGridData[this.updatedCellData.rowIndex][columnPeriod] = "X";

			this.intersectionGridComponent.instance.repaint();

			return;
		}

		let cellValue: any = rowData[columnPeriod];





		if (this.upsertLevelingDisplacementMultipleDto.EsoObjectIds.length === 0) {
			this.upsertLevelingDisplacementMultipleDto.EsoObjectIds = this.selectedTableRecords.map((value) => value.EsoObjectId);
		}

		let data: DisplacementDto = this.upsertLevelingDisplacementMultipleDto.Data.find(value => value.DisplaceFrom === rowPeriod && value.DisplaceTo === columnPeriod);

		if (!data) {
			data = new DisplacementDto();

			data.DisplaceFrom = rowPeriod;
			data.DisplaceTo = columnPeriod;

			this.upsertLevelingDisplacementMultipleDto.Data.push(data);
		}


		data.DisplaceQty = +cellValue;

	}

	@Output() public onIntersectionGridSaved: EventEmitter<StatusMessageResultDto> = new EventEmitter<StatusMessageResultDto>();

	public intersectionGridSaveButtonClicked(event: any): void {
		console.log(
			"intersectionGridSaveButtonClicked - event:",
			event,
			"\nupsertLevelingDisplacementMultipleDto:",
			this.upsertLevelingDisplacementMultipleDto
		);

		this._esoService.upsertLevelingDisplacementMultiple(this.upsertLevelingDisplacementMultipleDto, false).subscribe(//this.isSplitBasedOnLeveledForecast).subscribe(
			(response) => {
				this.onIntersectionGridSaved.emit(response);
			}
		);

		this.upsertLevelingDisplacementMultipleDto = new UpsertLevelingDisplacementMultipleDto();
	}

	public intersectionGridDeleteButtonClicked(event: any): void {
		const $this = this;

		const defaultConfirmationPopUp = this._confirmationPopUpService.getPreset(ConfirmationPopUpService.ConfirmationPopUpPresetType.DEFAULT);

		defaultConfirmationPopUp.buttonsData[0].onClick.subscribe(
			(value) => {
				$this._esoService.deleteLevelingDisplacementMultiple($this.selectedTableRecordsEsoObjectsIds).subscribe(
					(response) => {
						if (response.success) {
							$this.update();
						}
					}
				);
			}
		);

		this._confirmationPopUpService.show(defaultConfirmationPopUp);
	}

	public intersectionGridSelectionChanged(event: any): void {
		console.log("intersectionGridSelectionChanged - event:", event);
	}

	public update(): void {
		this.selectedTableRecordsEsoObjectsIds = this.selectedTableRecords.map((value) => value.EsoObjectId);

		this.levelingSideGridDataSource.reload();
	}

	private initializeCoreSettings(): void {
		const $this = this;

		this._settingsService.getCoreSetting(
			null,
			"IsSplitBasedOnLevelledForecastDefaultValue",
			undefined,
			{
				showLoadingIndicator: false,
			}
		).then(
			(response) => {
				$this.isSplitBasedOnLevelledForecastDefaultValue = response;

				$this.isSplitBasedOnLeveledForecast = $this.isSplitBasedOnLevelledForecastDefaultValue.value === 'Yes';
			}
		);

		this._settingsService.getCoreSetting(
			3075,
			null,
			undefined,
			{
				showLoadingIndicator: false,
			}
		).then(
			(response) => {
				$this.levelingLeftSideGridColumns[0].caption = response.value;
			}
		);

		this._settingsService.getCoreSetting(
			5504,
			null,
			undefined,
			{
				showLoadingIndicator: false,
			}
		).then(
			(response) => {
				$this.levelingTopSideGridColumns[0].caption = response.value;
			}
		);

		this._settingsService.getCoreSetting(
			5505,
			null,
			undefined,
			{
				showLoadingIndicator: false,
			}
		).then(
			(response) => {
				$this.levelingLeftSideGridColumns[1].caption = response.value;
			}
		);
	}

	constructor(
		private _esoService: EsoService,
		private _forecastService: ForecastService,
		private _notificationService: NotificationService,
		private _confirmationPopUpService: ConfirmationPopUpService,
		private _settingsService: SettingsService,
	) { }

	ngOnInit() {
		this.onIntersectionGridSaved.subscribe((response) => this.update());

		this.initializeCoreSettings();
	}
}
